<template>
  <vp-page>
    <vp-tabs>
      <vp-router-outlet></vp-router-outlet>

      <vp-tab-bar slot="bottom">
        <vp-tab-button tab="menu1-1" href="/menu1/menu1-1">
          <vp-icon aria-hidden="true" :icon="shieldCheckmarkOutline" />
          <vp-label>안전관리</vp-label>
        </vp-tab-button>

        <vp-tab-button tab="menu1-2" href="/menu1/menu1-2">
          <vp-icon aria-hidden="true" :icon="peopleOutline" />
          <vp-label>근로자관리</vp-label>
        </vp-tab-button>

        <vp-tab-button tab=""></vp-tab-button>

        <vp-tab-button tab="menu1-3" href="/menu1/menu1-3">
          <vp-icon aria-hidden="true" :icon="businessOutline" />
          <vp-label>운영관리</vp-label>
        </vp-tab-button>

        <vp-tab-button tab="menu1-4" href="/menu1/menu1-4">
          <vp-icon aria-hidden="true" :icon="starOutline" />
          <vp-label>즐겨찾기</vp-label>
        </vp-tab-button>
      </vp-tab-bar>
    </vp-tabs>

    <vp-fab-buttons @top="handleMoveTop"></vp-fab-buttons>
  </vp-page>
</template>

<script setup>
//---------------------------------------------------------------------------------------------------------------------
// import
//---------------------------------------------------------------------------------------------------------------------
import { defineProps, inject, onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSettingsStore } from '@/stores/modules/settings'

//---------------------------------------------------------------------------------------------------------------------
// 변수 선언 && 함수 선언
//---------------------------------------------------------------------------------------------------------------------
const { shieldCheckmarkOutline, peopleOutline, businessOutline, starOutline } =
  inject('VpIcons')

const pageTitle = ref()

const settingsStore = useSettingsStore()
const isSettingsStore = storeToRefs(settingsStore)

const props = defineProps({
  useBackButton: {
    type: Boolean,
    default: true
  }
})

const handleMoveTop = () => {}

//---------------------------------------------------------------------------------------------------------------------
// life Cycle
//---------------------------------------------------------------------------------------------------------------------
onMounted(() => {
  pageTitle.value = isSettingsStore.getTitle.value
})
</script>

<style scoped>
ion-fab.md.fab-horizontal-center.fab-vertical-bottom {
  bottom: 30px;
}
</style>
